import type { PostBodyFilters } from '~/interfaces/app';

export default function initRequestBody(query: object): PostBodyFilters {
  // получаем параметры запроса в виде "ключ: значение"
  if (query && Object.entries instanceof Function) {
    return <PostBodyFilters>Object.entries(query).reduce(
      (sum, [key, val]) => {
        // Проверка на совпадение ключа с одним из условий регулярки.
        // Возвращаем массив содержащий результаты сопоставления для групп запроса
        const match = key.match(
          /^(range-(.+))|(attr-(.+))|(discount)|(brand_id)|(shop_ids)|(price)|(best_price)/
        );
        let filterValue = null;
        switch (true) {
          case Boolean(match?.[1]): // значение группы "(range-(.+))" полученное с выделенным ID: ключ в match[1], значение в match[2]
            filterValue = typeof val === 'string' ? val.split(',') : null;
            filterValue = filterValue && {
              id: Number(match![2]),
              value: {
                min: Number(filterValue[0]),
                max: Number(filterValue[1]),
              },
            };
            return filterValue
              ? { ...sum, filters: sum.filters.concat(filterValue) }
              : sum;
          case Boolean(match?.[3]):
            // значение группы "(attr-(.+))" полученное с выделенным ID: ключ в match[3], значение в match[4],
            // например: attr-23518 => match[3] = 'attr', match[4]= '23518'
            filterValue = {
              id: Number(match![4]),
              value: val
                ? // в самом деле "бинарные" атрибуты, attr-ID=true
                  val === 'true'
                  ? true
                  : (<string>val).split(',').filter((el) => {
                      return !isNaN(Number(el)) ? Number(el) : false;
                    })
                : true,
            };
            return filterValue
              ? { ...sum, filters: sum.filters.concat(filterValue) }
              : sum;
          case Boolean(match?.[5]): // значение группы "(discount)"
            return { ...sum, discount: 1 };
          case Boolean(match?.[6]): // значение группы "(brand_id)"
            return {
              ...sum,
              brand_id: (<string>val).split(',').map((el) => Number(el)),
            };
          case Boolean(match?.[7]): // значение группы "(shop_ids)"
            return {
              ...sum,
              shop_ids: (<string>val).split(',').map((el) => Number(el)),
            };
          case Boolean(match?.[8]): // значение группы "(price)"
            filterValue = typeof val === 'string' ? val.split(',') : null;
            return filterValue
              ? {
                  ...sum,
                  price: {
                    min: Number(filterValue[0]),
                    max: Number(filterValue[1]),
                  },
                }
              : sum;
          case Boolean(match?.[9]): // значение группы "(best_price)"
            return { ...sum, best_price: 1 };
          default:
            return sum;
        }
      },
      { filters: [], thereIsData: false }
    );
  }
  return { filters: [] };
}
